<template>
  <div>
    <span>Action not allowed</span>
  </div>
</template>

<script>
export default {
  name: 'PageNotAllowed',
}
</script>

<style lang="scss">

</style>